// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QtJa","rootNoMargin":"styles_rootNoMargin__i72Ap"};